import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import {PictureAsPdfOutlined} from '@material-ui/icons';
import LabelValue from '../../../shared/labelvalue/LabelValue.js';
import ContainedButton from '../../../shared/buttons/ContainedButton.tsx';
import TextButton from '../../../shared/buttons/TextButton.tsx';
import TabelaProcessosSeletivos from '../../components/inscricao/TabelaProcessosSeletivos.jsx';
import useCarregamentoPagina from '../../components/useCarregamentoPagina.js';
import useCreateFile from '../../../../hooks/useCreateFile.js';
import {salvarArquivoResposta} from '../../../../utils/download.js';
import {URL_INSCRICOES_ARQUIVOS_FICHAS} from '../../../../constants/index.js';

const CORPO = {};

const useStyles = makeStyles(() => ({
    root: {
        width: 800,
        maxWidth: '100%'
    },
    contentRoot: {overflowY: 'initial'}
}));

/* Fichas de inscrição de todo um processo de seleção, em um único PDF (módulo CFGERFIINS). */
export default function DialogFichasProcesso(props) {
    const {open, onClose} = props;
    const classes = useStyles();
    const [createFile, gerando] = useCreateFile({returnInnerLoadingState: true});

    // Geração do arquivo pelo LoadingModal global (sem spinner dentro do diálogo).
    useCarregamentoPagina(gerando);
    const [processo, setProcesso] = useState(null);
    const [fichaFinal, setFichaFinal] = useState('false');

    // Cada abertura começa sem processo escolhido e com ficha parcial.
    useEffect(() => {
        if (open) {
            setProcesso(null);
            setFichaFinal('false');
        }
    }, [open]);

    const handleGerar = () => {
        createFile(`${URL_INSCRICOES_ARQUIVOS_FICHAS(processo.id)}?final=${fichaFinal === 'true'}`, CORPO, response => {
            salvarArquivoResposta(response, 'fichas-inscricao.pdf');
            onClose();
        });
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            classes={{paper: classes.root}}
            scroll='body'
            aria-labelledby='dialog-fichas-processo-titulo'>
            <DialogTitle id='dialog-fichas-processo-titulo'>Fichas de Inscrição</DialogTitle>
            <DialogContent classes={{root: classes.contentRoot}}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TabelaProcessosSeletivos onSelecionar={setProcesso}/>
                    </Grid>
                    <Grid item xs={12}>
                        <LabelValue label='Ficha final/concluída?'>
                            <FormControl component='fieldset'>
                                <RadioGroup
                                    row
                                    aria-label='Ficha final/concluída'
                                    value={fichaFinal}
                                    onChange={event => setFichaFinal(event.target.value)}>
                                    <FormControlLabel value='true' control={<Radio color='primary'/>} label='Sim'/>
                                    <FormControlLabel value='false' control={<Radio color='primary'/>} label='Não'/>
                                </RadioGroup>
                            </FormControl>
                        </LabelValue>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <TextButton onClick={onClose}>Fechar</TextButton>
                <ContainedButton
                    startIcon={<PictureAsPdfOutlined/>}
                    disabled={gerando || !processo}
                    onClick={handleGerar}>
                    Gerar Fichas de Inscrição
                </ContainedButton>
            </DialogActions>
        </Dialog>
    );
}

DialogFichasProcesso.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};
